import type { MoodCheckMode } from '@/store/sessionTypes'
import type { SessionStartOptions } from '@/utils/sessionStartFlow'

export const SESSION_START_OPTIONS_KEY = 'fitutogether-session-start-options'

const MOOD_CHECK_MODES: MoodCheckMode[] = ['together', 'client-only', 'separately', 'none']

function isMoodCheckMode(value: unknown): value is MoodCheckMode {
  return typeof value === 'string' && MOOD_CHECK_MODES.includes(value as MoodCheckMode)
}

export function parseSessionStartOptions(data: unknown): SessionStartOptions | null {
  if (!data || typeof data !== 'object') return null
  const parsed = data as Partial<SessionStartOptions>
  if (
    typeof parsed.includeWotCheck !== 'boolean' ||
    typeof parsed.includeWarmup !== 'boolean' ||
    !isMoodCheckMode(parsed.moodCheckMode)
  ) {
    return null
  }
  return {
    includeWotCheck: parsed.includeWotCheck,
    includeWarmup: parsed.includeWarmup,
    moodCheckMode: parsed.moodCheckMode,
  }
}

export function readPersistedSessionStartOptions(): SessionStartOptions | null {
  try {
    const raw = localStorage.getItem(SESSION_START_OPTIONS_KEY)
    if (!raw) return null
    return parseSessionStartOptions(JSON.parse(raw))
  } catch {
    return null
  }
}

export function writePersistedSessionStartOptions(options: SessionStartOptions): void {
  try {
    localStorage.setItem(SESSION_START_OPTIONS_KEY, JSON.stringify(options))
  } catch {
    /* quota — fail silently */
  }
}
